











import { Component, Vue } from 'vue-property-decorator';
import OtPhoneNumberField from '@/components/global/ot-phone-number-field.vue';

@Component({
  components: {
    OtPhoneNumberField,
  },
})
export default class OtPhoneNumberFieldWrapper extends Vue {
  // * PROPS

  // * REFS

  // * DATA
  private data = null;

  // * COMPUTED

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
